import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faFileCertificate } from '@fortawesome/pro-light-svg-icons';

export type ProLightFileCertificateProps = IconComponentProps;

export const ProLightFileCertificate = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightFileCertificateProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faFileCertificate}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faFileCertificate}
    />
  );
};

ProLightFileCertificate.displayName = 'ProLightFileCertificate';
